// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__282po","formControl":"addForm_formControl__C3Bgt","list":"addForm_list__g2j81","btnWrpper":"addForm_btnWrpper__7bNXu"};